import './App.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Component } from 'react';
import Home from './components/Home/Home';
import { BrowserRouter as Router, Link, Route, Routes, useLocation} from 'react-router-dom';
import AllCouponsComponent from './components/Coupons/All-Coupons/allCoupons.component';
import EventsComponent from './components/Events/events.component';
import FidelityCard from './components/FidelityCard/fidelityCard';
import FlyersComponent from './components/Flyers/flyers.component';
import PromoComponent from './components/Promo/promo.component';
import CatalogRewardsComponent from './components/RewardsCatalog/rewardsCatalog.component';
import ServiceComponent from './components/Service/service.component';
import FooterComponent from './components/Footer/footer.component';
import LoginComponent from './components/Login/login';
import SubheaderComponent from './components/SubHeader/subHeader.component';
import ToolbarComponent from './components/Toolbar/toolbar';
import { sessionUserValid } from './service/serviceMain';
import MenuComponent from './components/Menu/Menu';
import SignupComponent from './components/UserSignup/signup';
import RecoveryPasswordComponent from './components/RecoveryPassword/recoveryPassword';
import PharmaTabComponent from './components/Pharmacy/pharma-tab/pharmaTab.component';
import YouRewardsComponent from './components/YouRewards/yourRewards.component';
import { setKey } from 'react-geocode';
import { googleMapsApiKey } from './static/google-map-key';
import { goTo } from './utilities/common.utilities';
import ManagePrivacyComponent from './components/ManagePrivacy/managePrivacy';
import WelcomeAnimateComponent from './components/WelcomeAnimate/welcome-animate.component';
import ChangePasswordComponent from './components/ChangePassword/changePassword.component';
import { Toast } from 'primereact/toast';
import { ConnectivityContext, ConnectivityContextType, ConnectivityProvider} from './context/connectivityContext';
import { CacheRouteWatcherComponent } from './components/CacheRouteWatcher/cacheRouteWatcher.component';
//import OfflineComponent from './components/Offline/offline.component';
import { Dialog } from 'primereact/dialog'; // Import Dialog per il popup
import { Button } from 'primereact/button'; // Per il pulsante con l'icona
import EasySignupComponent from './components/EasySignup/EasySignup.component';

type Theme = "dark" | "high-contrast" | "light-blue";

type State = {
  isLogged: boolean;
  showAnimation: boolean;
  isOnline: boolean;
  showContainerReturnOnline: boolean; // indica se deve mostrare il div "Sei di nuovo online"

  // indica se bisogna translare la toolbar perchè sopra c'è l'elemento che indica lo stato della connettività
  // (Nessuna connessione / Sei di nuovo online)
  applyTranslateToolbar: boolean;
  theme: Theme; // Stato per il tema
  themeChanged: boolean;
};

type FooterProps = {
  theme: Theme;
};


setKey(googleMapsApiKey); // imposta la chiave per l' api di geocodifica della libreria 'react-geocode'

class App extends Component<{}, State> {
  cleanupNavigationTracker: (() => void) | null = null;
  static contextType = ConnectivityContext; // Associa il contesto al componente
  context!: ConnectivityContextType; // Tipizza il contesto (la "!" serve per dire a TypeScript che non sarà undefined)

  state: State = {
    isLogged: sessionUserValid(),
    showAnimation: true,
    isOnline: navigator.onLine,
    showContainerReturnOnline: false,
    applyTranslateToolbar: false,
    theme: (localStorage.getItem("theme") as Theme) || "light-blue",
    themeChanged: false
  };

  // handleThemeChange = (newTheme: Theme) => {
  //   // Salva il tema in localStorage
  //   localStorage.setItem("theme", newTheme);

  //   // Aggiorna lo stato del tema
  //   this.setState({ theme: newTheme });

  //   // *** Aggiunge la classe del tema al <body> ***
  //   document.body.classList.remove( "theme-dark", "theme-high-contrast", "theme-light-blue");
  //   document.body.classList.add(`theme-${newTheme}`);
  // };

  handleThemeChange = (newTheme: Theme) => {
    const currentTheme = localStorage.getItem('theme');

    if(currentTheme && currentTheme !== newTheme) {
      localStorage.setItem('previousTheme', currentTheme);
      this.setState({ themeChanged: true });
    } else {
      localStorage.setItem('previousTheme', newTheme);
      this.setState({ themeChanged: false });
    }

    localStorage.setItem('theme', newTheme);

    this.setState({ theme: newTheme });

    document.body.classList.remove("theme-dark", "theme-high-contrast", "theme-light-blue");
    document.body.classList.add(`theme-${newTheme}`);
  };

  constructor(props: any) {
    super(props);

    //this.previousLocation.current = ''
    this.showReturnOnline = this.showReturnOnline.bind(this);
    this.showStatusOffline = this.showStatusOffline.bind(this);
    this.pullRechargeData = this.pullRechargeData.bind(this);
  }

  manageRedirect() {
    // Se si è loggati è sono necessarie operazioni sul menù
    if (
      this.state.isLogged &&
      localStorage.getItem("necessaryActionMenu") === "true"
    ) {
      // eseguo un redirect nel menù, se l'utente sta su un'altra pagina
      if (window.location.pathname !== "/menu") {
        goTo("/menu");
      }
    } 
    // else if (
    //   this.state.isLogged &&
    //   window.location.pathname === "/login"
    //   // window.location.pathname !== "/home" &&
    //   // window.location.pathname !== "/" &&
    //   // window.location.pathname !== "/menu" &&
    //   // window.location.pathname !== "/yourRewards" &&
    //   // window.location.pathname !== "/privacy"
    // ) {
    //   goTo( '/home');
    // }
  }
  componentDidMount() {
    // Ottieni tutte le entry di tipo 'navigation'
    const navigationEntries = performance.getEntriesByType("navigation");

    if (navigationEntries.length > 0) {
      // Cast a PerformanceNavigationTiming per accedere alla proprietà 'type'
      const navigationEntry =
        navigationEntries[0] as PerformanceNavigationTiming;

      // Se non c'è il flag, l'utente ha ricaricato la pagina: puliamo il localStorage
      if (navigationEntry.type === "reload" && this.state.isOnline) {
        this.pullRechargeData();
      }
    }

    // Applica il tema salvato al body
    document.body.classList.add(`theme-${this.state.theme}`);

    this.manageRedirect();

    // Aggiorna la variabile di stato connessione il valore dal contesto
    this.setState({ isOnline: this.context.isOnline });

    if (navigator.onLine) {
      this.setState({
        showContainerReturnOnline: false,
        applyTranslateToolbar: false,
      });
    } else {
      this.setState({
        showContainerReturnOnline: false,
        applyTranslateToolbar: true,
      });
    }

    // window.addEventListener('online', this.showReturnOnline);
    // window.addEventListener('offline', this.showStatusOffline);

    setTimeout(() => {
      if (!this.state.isLogged && window.location.pathname === "/") {
        this.setState({ showAnimation: false });
      }
    }, 3300);
    // if(this.state.isLogged &&
    //   (window.location.pathname !== '/home' && window.location.pathname !== '/' && window.location.pathname !== '/menu' && window.location.pathname !== '/yourRewards' && window.location.pathname !== '/privacy')
    // ) {
    //   goTo( '/home');
    // }

    window.addEventListener('popstate', this.handlePopState);
  }

  pullRechargeData = () => {
    //removeLocalStorageAfterChangeCard()
    // return new Promise<void>((resolve) => {
    // this.setState({ isLoading: true });
    localStorage.removeItem("services");
    localStorage.removeItem("allCustomerInfo");
    localStorage.removeItem("pharmacyInfo");
    localStorage.removeItem("catalogs");
    localStorage.removeItem("points");
    localStorage.removeItem("rewards");
    localStorage.removeItem("getPrivacyProfile");
    localStorage.removeItem("getPrivacyInfo");
    localStorage.removeItem("GET_ALL_CUSTOMER_TIME");
    localStorage.removeItem("GET_REWARDS_TIME");
    localStorage.removeItem("GET_SERVICES_TIME");
    localStorage.removeItem("GET_CATALOG_TIME");
    localStorage.removeItem("GET_PHARMAINFO_TIME");
    localStorage.removeItem("GET_PROFILE_TIME");
    localStorage.removeItem("GET_POINTS_TIME");
    localStorage.removeItem("GET_PRIVACY_PROFILE");
    localStorage.removeItem("GET_PRIVACY_INFO");
    //window.location.reload();
    //resolve();
    // });
  };

  // Funzione richiamata quando si è di nuovo online
  showReturnOnline() {
    // this.setState({isOnline: true, showContainerReturnOnline: true, applyTranslateToolbar: true})
    this.setState({
      showContainerReturnOnline: true,
      applyTranslateToolbar: true,
    });
    setTimeout(() => {
      if (this.state.isOnline) {
        this.setState({ applyTranslateToolbar: false });
      } else {
        //console.log('no apply false perchè di nuovo offline')
      }
    }, 4000);
  }

  showStatusOffline() {
    // this.setState({isOnline: false, showContainerReturnOnline: false, applyTranslateToolbar: true});
    this.setState({
      showContainerReturnOnline: false,
      applyTranslateToolbar: true,
    });
  }

  componentDidUpdate(prevProps: never, prevState: State) {
    // Se il valore del contesto cambia, aggiorna lo stato
    if (prevState.isOnline !== this.context.isOnline) {
      this.setState({ isOnline: this.context.isOnline });

      // una volta cambiato il valore
      if (this.context.isOnline) {
        this.showReturnOnline();
      } else {
        this.showStatusOffline();
      }
    }
  }

  handlePopState = () => {
    const storedTheme = localStorage.getItem("theme") as Theme;
    if (storedTheme && storedTheme !== this.state.theme) {
      this.handleThemeChange(storedTheme);
    }
  };
  
  componentWillUnmount(): void {
    // window.removeEventListener('online', this.showReturnOnline);
    // window.removeEventListener('offline', this.showStatusOffline);
    window.removeEventListener('popstate', this.handlePopState);
  }


  render() {
    const { theme, applyTranslateToolbar } = this.state;

    // Se stai su /easySignup, ritorna direttamente il componente e STOP
    if (window.location.pathname.startsWith("/easySignup")) {
      return (
        <Router>
          <Routes>
            {/* <Route path="/easySignup/:storeCodeEncrypted" element={<EasySignupComponent />} /> */}
            <Route path="/easySignup/:storeCodeEncrypted/:source" element={<EasySignupComponent />} />
            <Route path="/easySignup" element={<div>Store code mancante</div>} />
          </Routes>
        </Router>
      );
    }
    // if(this.state.isLogged &&
    //   (window.location.pathname !== '/home' && window.location.pathname !== '/' && window.location.pathname !== '/menu' && window.location.pathname !== '/yourRewards')
    //  ) {
    //   goTo( '/home');
    // }
    this.manageRedirect();

    return (
      <Router>
        {/* <div className={`app theme-${theme}`}> */}
        <CacheRouteWatcherComponent />

        {!this.state.isLogged && window.location.pathname === "/" ? (
          <WelcomeAnimateComponent show={this.state.showAnimation} />
        ) : (
          <></>
        )}

        <div
          // className={
          //   this.state.applyTranslateToolbar ? "translate-element-home" : ""
          // }
          className={`app theme-${theme} ${applyTranslateToolbar ? "translate-element-home" : ""}`}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minHeight: "inherit",
            position: "relative",
          }}
        >
          {!this.state.isOnline ? (
            // <div className={ 'flex flex-column ' + (this.state.isOnline ? 'opacity-0' : 'opacity-100 banner-menu-no-connection ') }>
            <div
              id="banner-state-connection"
              className="flex flex-column banner-menu-no-connection"
            >
              <div className="flex align-items-center justify-content-center w-full h-full">
                {/* <i className='bi bi-cloud-slash mr-2' style={{ fontSize: '1rem' }}></i> */}
                <img
                  src="/offline_globe.svg"
                  alt=""
                  draggable="false"
                  style={{
                    width: "11px",
                    height: "11px",
                    marginRight: "0.1rem",
                  }}
                />
                <span className="font-footer">Nessuna connessione</span>
              </div>
            </div>
          ) : (
            <></>
          )}

          {this.state.showContainerReturnOnline ? (
            <div
              id="banner-state-connection"
              className="flex flex-column banner-menu-reconnection"
            >
              <div className="flex align-items-center justify-content-center w-full h-full">
                <i
                  className="bi bi-globe-americas"
                  style={{ fontSize: "11px", marginRight: "0.1rem" }}
                ></i>
                <span className="font-footer">Sei di nuovo Online</span>
              </div>
            </div>
          ) : (
            <></>
          )}

          {this.state.isLogged ? (
            <>
              {window.location.pathname !== "/login" &&
              window.location.pathname !== "/menu" &&
              window.location.pathname !== "/privacy" ? (
                <>
                  <ToolbarComponent />
                  <SubheaderComponent />                  
                  <div
                    className={
                      "content " +
                      (this.state.applyTranslateToolbar
                        ? "translate-content-page"
                        : "")
                    }
                    style={{ overflow: "auto", height: "100%" }}
                  >
                    <Link to={"/home"}></Link>
                    <Routes>
                      <Route path="/" element={<Home />}></Route>
                      <Route path="/home" element={<Home />}></Route>
                      <Route
                        path="/fidelity-card"
                        element={<FidelityCard />}
                      ></Route>
                      <Route
                        path="/rewards-points"
                        element={<CatalogRewardsComponent />}
                      ></Route>
                      <Route
                        path="/coupons"
                        element={<AllCouponsComponent />}
                      ></Route>
                      <Route
                        path="/events"
                        element={<EventsComponent />}
                      ></Route>
                      <Route path="/promo" element={<PromoComponent />}></Route>
                      <Route
                        path="/service"
                        element={<ServiceComponent />}
                      ></Route>
                      <Route
                        path="/pharmacy"
                        element={<PharmaTabComponent />}
                      ></Route>
                      <Route
                        path="/flyers"
                        element={<FlyersComponent />}
                      ></Route>
                      <Route
                        path="/yourRewards"
                        element={<YouRewardsComponent />}
                      ></Route>
                    </Routes>
                  </div>
                  <FooterComponent theme={this.state.theme} />
                </>
              ) : window.location.pathname === "/privacy" ? (
                <ManagePrivacyComponent />
              ) : window.location.pathname === "/login" ? (
                <LoginComponent />
              ) : (
                <MenuComponent onThemeChange={this.handleThemeChange} currentTheme={this.state.theme} themeChanged={this.state.themeChanged} />
              )}
            </>
          ) : window.location.pathname === "/login" ? (
            <LoginComponent />
          ) : window.location.pathname === "/signup" ? (
            <SignupComponent />
          ) : window.location.pathname === "/forgot-password" ? (
            <RecoveryPasswordComponent />
          ) : window.location.pathname.includes("/change-password") ? (
            <ChangePasswordComponent />
          ) : (
            // :
            // window.location.pathname === "/offline" ?
            //   <OfflineComponent/>
            <LoginComponent />
          )}
        </div>
      {/* </div> */}
      </Router>
    );
  }
}

export default App;
